export default {
  actions: {
    map: {
      docs: 'documentation',

      label: 'Or create your first map',
      new: 'Create map'
    },
    workflow: {
      new: 'Create workflow',
      label: 'Or create your first workflow'
    },
    lastMaps: {
      title: 'Recent maps',
      all: 'View all'
    },
    lastWorkflows: {
      title: 'Recent workflows',
      all: 'View all'
    }
  },
  gettingStarted: {
    title: 'Introducing the new CARTO platform',
    subtitle: 'Getting Started'
  },
  blog: {
    title: "What's new",
    subtitle: 'From our blog',
    visit: 'Visit blog'
  },
  onboarding: {
    welcome: {
      title: 'Welcome to CARTO',
      content:
        "Get started by creating stunning maps and bringing your spatial data to life! Enrich your analysis with our Data Observatory, build powerful apps, and more — you'll be soon turning your location data into powerful insights.",
      buttons: {
        gettingStarted: {
          title: 'Getting started',
          description: 'Bring your data and create your first map'
        },
        accessTutorials: {
          title: 'Access CARTO Academy',
          description: 'Solve interesting use cases following our guides'
        },
        documentation: {
          title: 'Check our documentation',
          description: 'Unlock the full potential of CARTO technology'
        }
      },
      videos: {
        title: 'Quickstart videos'
      }
    },
    onboardingVideo: {
      workspaceTitle: 'Welcome to CARTO',
      builderTitle: 'Welcome to CARTO Builder',
      workflowsTitle: 'Welcome to CARTO Workflows',
      aiAgentTitle: 'Introducing CARTO AI Agents',
      agenticGISTitle: 'Introducing Agentic GIS',
      watchVideoButton: 'Watch video',
      skipButton: 'Skip guide',
      description: {
        workspace:
          'CARTO is the leading spatial analytics platform built for the cloud, allowing you to analyze, visualize and develop with spatial data at limitless scale natively in your data warehouse.{gap}<strong>Learn everything you need to know</strong> to get started with CARTO and how to make the most out of your spatial data.',
        builder:
          'CARTO Builder is our map-making tool, allowing you to create highly scalable interactive maps natively in your cloud data warehouse. With Builder, you can accelerate decision-making and share your analysis results with ease.{gap}<strong>Learn more about CARTO Builder</strong> and how to create and share your first interactive map!',
        workflows:
          'CARTO Workflows allows you to build and automate data preparation and spatial analysis pipelines with a low-code, simple interface - all running directly in your data warehouse.{gap}<strong>Learn more about CARTO Workflows</strong>, its available components and templates, and quickstart your spatial analysis!',
        aiAgent:
          'CARTO AI Agents enhance your Builder maps with conversational interactivity. Increase the engagement in your maps by allowing more users to uncover insights with support from our AI Agents{gap}<strong>This feature is currently in preview</strong>. We are already working on our next version of faster, smarter and more powerful AI Agents for your maps! Stay tuned!',
        agenticGIS:
          "Agentic GIS makes spatial insights accessible to everyone. Build AI Agents that your organization can use to turn complex geospatial data into clear, actionable insights. AI Agents leverage built-in tools and can be extended with Workflows MCP Tools you create to automate analyses and deliver tailored recommendations.{gap}CARTO's MCP Server can also connect to third-party AI platforms, democratizing spatial analytics and helping teams move from analysis to decisions faster."
      }
    },
    checklist: {
      title: 'Getting started',
      completed: 'completed',
      skipLink: "I'm ready, skip onboarding",
      confirmation: {
        title: 'Congrats! You’re an expert',
        content:
          'Discover the most advanced spatial data analysis and visualizations right in the CARTO workspace.<br></br>Visit <a>our documentation</a> to learn more.',
        button: 'Close onboarding'
      },
      tasks: {
        checkDemoMap: 'Check how one of our demo maps was built',
        buildFirstMap: 'Build your first map',
        browseDataExplorer: 'Connect and explore your data',
        browseDoCatalog: 'Explore the Data Observatory ',
        inviteColleagues: 'Invite your colleagues to CARTO',
        buildFirstWorkflow: 'Build your first workflow'
      }
    },
    maps: {
      title: 'Start with your spatial analysis'
    },
    workflows: {
      title: 'Start creating workflows'
    },
    dataWarehouse: {
      title: 'Connect your data warehouse',
      content:
        'Seamlessly interact with data hosted in your cloud data warehouse, eliminating ETL complexity and any limits on scalability.',
      button: 'Create new connection'
    },
    import: {
      title: 'Upload local files',
      content: 'Upload your own datasets and use them to create new spatial analysis.',
      button: 'Import your data'
    }
  },
  noCartoDW: {
    getStarted: 'GET STARTED'
  },
  datasets: {
    emptyTitle: 'No recent data explored yet.',
    emptyContent: 'Explore your connections, search datasets to find what you need, or import new source.',
    title: 'Recently used data',
    explore: 'Explore data',
    import: 'Import dataset'
  },
  apps: {
    card: {
      siteSelection: 'Site selection',
      goToApp: 'Go to app'
    }
  }
}
